module.exports = __webpack_public_path__ + "img/small-yandex.f52892bd.svg";